
import { ref } from '../../_snowpack/pkg/vue.js';
import LaunchList from '../components/LaunchList.vue.js';

const defaultExport = {
  components: { LaunchList },
  setup() {
    const limit = ref(parseInt(localStorage.limit));

    return { limit };
  },
  methods: {
    toHome() {
      this.$router.push({ name: 'Home' });
    }
  }
};

import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "../../_snowpack/pkg/vue.js"

const _hoisted_1 = { class: "apollo container-lg" }
const _hoisted_2 = { class: "fw-bolder text-center p-5 m-5" }
const _hoisted_3 = { class: "d-flex justify-content-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-reply-fill me-2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.921 11.9 1.353 8.62a.719.719 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Re-Launch", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  const _component_LaunchList = _resolveComponent("LaunchList")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, " SpaceX Past " + _toDisplayString(_ctx.limit) + " Missions ", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-warning btn-lg mb-5 d-flex align-items-center",
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toHome && _ctx.toHome(...args)))
      }, _hoisted_6)
    ]),
    (_ctx.limit)
      ? (_openBlock(), _createBlock(_component_LaunchList, {
          key: 0,
          limit: _ctx.limit
        }, null, 8, ["limit"]))
      : _createCommentVNode("", true)
  ]))
};

defaultExport.render = render;

export default defaultExport;